// extracted by mini-css-extract-plugin
export default {"root":"SchedulesFormJSON_root__FRpXT","mono":"SchedulesFormJSON_mono__6iKpS","actions":"SchedulesFormJSON_actions__YPHJb","separator":"SchedulesFormJSON_separator__H-OMV"};